import { h, Component } from 'preact'
import { removeFromCompare } from '../helpers/compare'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class ProductPreview extends Component {
  state = {
    isRemoved: false
  }
  handleRemove(e, id) {
    e.preventDefault()
    this.setState({
      isRemoved: true
    })
    // Remove from compare
    removeFromCompare(id)
    // Reset product count
    this.props.setProductCount()
  }

  handleClick(e) {
    const dropdownLists = document.querySelectorAll('.js-options-list')
    const dropdownTitles = document.querySelectorAll('.js-options-title')
    ;[...dropdownLists].forEach(dropdown => {
      if (dropdown.classList.contains('c-single-product__options--active')) {
        dropdown.classList.remove('c-single-product__options--active')
      } else {
        dropdown.classList.add('c-single-product__options--active')
      }
    })
    ;[...dropdownTitles].forEach(title => {
      if (title.classList.contains('c-single-product__list-title--active')) {
        title.classList.remove('c-single-product__list-title--active')
      } else {
        title.classList.add('c-single-product__list-title--active')
      }
    })
  }

  render() {
    const { product } = this.props
    if (this.state.isRemoved) return null
    const specs = product.product_details.specs
      ? product.product_details.specs
      : []
    const options = product.product_details.options
      ? product.product_details.options
      : []

    return (
      <div className="c-single-product c-single-product--compare">
        <div className="c-single-product__inner">
          <div className="c-single-product__top-bar u-flex u-flex-sb u-flex-v-center">
            <h3 className="c-single-product__title">
              {product.title.rendered}
            </h3>
            <button
              className="c-single-product__remove-button u-clean-button"
              onClick={e => this.handleRemove(e, product.id)}
            >
              <span class="c-single-product__remove-content">verwijder</span>
              <svg
                className="c-icon c-icon--small c-single-product__icon"
                dangerouslySetInnerHTML={{
                  __html: '<use xlink:href="#close-2"></use>'
                }}
              />
            </button>
          </div>
          <div className="c-single-product__container">
            {/* <div className="c-single-product__intro">
              <p>{product.product_details.intro}</p>
            </div> */}
            <div className="c-single-product__image">
              <div
                className="c-single-product__background o-background"
                style={{ backgroundImage: `url(${product.thumbnail})` }}
              />
            </div>
            {specs.length > 0 ? (
              <div className="c-single-product__list">
                <div className="c-single-product__list-title">
                  Specificaties
                </div>
                <ul className="c-single-product__specs">
                  {specs.map(spec => {
                    return (
                      <li
                        className="c-single-product__spec"
                        dangerouslySetInnerHTML={{ __html: spec.spec }}
                      />
                    )
                  })}
                </ul>
              </div>
            ) : null}
            {options.length > 0 ? (
              <div className="c-single-product__list">
                <div
                  className="c-single-product__list-title c-single-product__list-title--options js-options-title"
                  onClick={this.handleClick}
                >
                  {' '}
                  <svg
                    className="c-icon c-icon--small c-single-product__chevron"
                    dangerouslySetInnerHTML={{
                      __html: '<use xlink:href="#chevron-right"></use>'
                    }}
                  />{' '}
                  Opties
                </div>
                <ul className="c-single-product__specs c-single-product__options js-options-list">
                  {options.map(option => {
                    return (
                      <li
                        className="c-single-product__spec"
                        dangerouslySetInnerHTML={{ __html: option.option }}
                      />
                    )
                  })}
                </ul>
              </div>
            ) : null}
            <div className="c-single-product__button-container">
              {product.buttons.map((button, index) => {
                let buttonClass =
                  index === 0
                    ? 'c-button c-button--primary c-single-product__button'
                    : 'c-button c-button--secondary c-single-product__button'
                return (
                  <a href={button.url} className={buttonClass}>
                    {button.content}
                    <svg
                      className="c-icon c-icon--xsmall c-button__icon"
                      dangerouslySetInnerHTML={{
                        __html: '<use xlink:href="#arrow-right-thin"></use>'
                      }}
                    />
                    {index === 0 ? (
                      <div className="c-pulse">
                        <div className="c-pulse__inner" />
                      </div>
                    ) : null}
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductPreview



// WEBPACK FOOTER //
// ./src/js/compare/components/ProductPreview.js